import axios from "axios";
import qs from "qs";
import { getToken } from "@/utils/auth";
import store from "@/store/index";

axios.defaults.withCredentials = true;
axios.defaults.headers["Content-Type"] = "application/json";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
  // time_out: 20000
});
console.log('process.env.VUE_APP_BASE_URL='+process.env.VUE_APP_BASE_URL);
// request interceptor
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers.Authorization = `Bearer ${getToken()}`;
    }
    //config.headers["x-leapin-lang-code"] = 'en';
    config.data = config.data || {};
    if (config.method === "get") {
      config.url = config.url + "?";
      config.url += qs.stringify(config.data);
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
// http error message
const codeMessage = {

};

// respone interceptor
service.interceptors.response.use(
  response => {
    if (response.status >= 200 && response.status < 300) {
      if (response.data.data.code === 0) {
        return response.data.data || {};
      }
      if (response.data.data.code === 403) {
        store.dispatch("user:fedLogOut").then(() => {
          window.location.href = "/";
        });
        return;
      }
      return response.data.data || {};
    }

    const errortext = codeMessage[response.status] || response.statusText;
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
  },
  error => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default service;
